goog.provide('el8.uiwidget.QuickSelectDialog');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.uiwidget.QuickSelectDialog');


/**
 * This is a subclass of NewDialog that presents a standard interface
 * for picking one item from a list of options.
 *
 * See, e.g., selectRelatedNote.js and apptStatusDetails.js
 */
el8.uiwidget.QuickSelectDialog = function(opts) {

    this._callbackFn = opts.callbackFn;
    this._list = opts.list || [];
    this._title = opts.title;
    this._footerMsg = opts.footerMsg;
    this._msg = opts.msg;
    this._getTextFn = opts.getTextFn || function(a) { return a; };
    this._listTemplateFn = opts.listTemplateFn;
    this._postShowFn = opts.postShowFn;

    /**
     * Set up options to pass into NewDialog
     */
    opts.autoHeight = true;
    opts.width = 400 || opts.width;
    opts.position = 'center';
    opts.modal = (opts.modal !== false); // default true
    opts.closeOnEscape = true;
    opts.showXButton = true;
    opts.contentFn = function() {
        return el8.template.uiwidget.QuickSelectDialog.content({
            footerMsg: this._footerMsg,
            msg: this._msg
        });
    };

    this.parent.constructor.call(this, opts);
};
el8.uiwidget.QuickSelectDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.uiwidget.QuickSelectDialog.prototype._init = function() {
    var that = this;
    this.parent._init.apply(this, arguments);
    this.getContentElt().on('click', '.select-option',  function(e) {
        var index = $(this).attr('_index')*1;
        return (that._callbackFn) ? that._callbackFn(index) : undefined;
    });

    this._isInit = true;
};

el8.uiwidget.QuickSelectDialog.prototype.show = function() {
    this.parent.show.apply(this, arguments);
    var arg = { list: this._list.map(this._getTextFn) };
    var htmlContent = this._listTemplateFn ?
        this._listTemplateFn(arg) :
        el8.template.uiwidget.QuickSelectDialog.list(arg);
    $('.select-options-content', this.getContentElt()).html(htmlContent);
    this.adjustPosition();
    this.focusButton(0);
    if (this._postShowFn) {
        this._postShowFn();
    }
};

el8.uiwidget.QuickSelectDialog.prototype.setItemCaption = function(index, caption) {
    $('.select-option-caption', this.getContentElt()).eq(index).text(caption);
};

el8.uiwidget.QuickSelectDialog.prototype.getItemCaption = function(index) {
    return $('.select-option-caption', this.getContentElt()).eq(index).text();
};

el8.uiwidget.QuickSelectDialog.prototype.focusButton = function(index) {
    $('.select-option[_index="'+index+'"]', this.getContentElt()).focusFocus();
};
